import type { StreamTraceSearchState, UHStreamMessage } from './UHStreamMessage';

export const isUHTraceContentSearch = (
	message: UHStreamMessage,
): message is StreamTraceSearchState =>
	message.type === 'TRACE' && message.message.message_template === 'CONTENT_SEARCH';
